import React from 'react';

type Season = 'christmas' | 'easter' | 'halloween' | 'valentines' | 'starwars' | 'earthday' | 'default';

const getSeason = (): Season => {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth();

  // Dez 6-24: Weihnachten
  if (month === 11 && day >= 6 && day <= 24) return 'christmas';

  // Osterwoche (dynamisch berechnet)
  if (isEasterWeek()) return 'easter';

  // Okt 25-31: Halloween
  if (month === 9 && day >= 25 && day <= 31) return 'halloween';

  // 14. Februar: Valentinstag
  if (month === 1 && day === 14) return 'valentines';

  // 4. Mai: Star Wars Day ("May the 4th be with you")
  if (month === 4 && day === 4) return 'starwars';

  // 22. April: Earth Day
  if (month === 3 && day === 22) return 'earthday';

  return 'default';
};

export const getFavoriteIcon = (outlined: boolean) => {
  const season = getSeason();

  switch (season) {
    case 'christmas':
      if (outlined) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <path
              className="svg-hover add-christmas"
              d="M50 2L68 28L58 28L80 48L65 48L90 75L65 75L65 95L35 95L35 75L10 75L35 48L20 48L42 28L32 28Z"
              fill="rgba(0, 0, 0, 0)"
              stroke="rgb(0, 0, 0, 0.25)"
              strokeWidth="8"
              strokeLinejoin="round"
              strokeLinecap="round"
            />
          </svg>
        );
      } else {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <path
              d="M50 2L68 28L58 28L80 48L65 48L90 75L65 75L65 95L35 95L35 75L10 75L35 48L20 48L42 28L32 28Z"
              fill="rgb(0, 128, 0, 0.5)"
              stroke="rgb(0, 128, 0, 0.5)"
              strokeWidth="8"
              strokeLinejoin="round"
              strokeLinecap="round"
            />
          </svg>
        );
      }
    case 'easter':
      if (outlined) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <path
              className="svg-hover add-easter"
              d="M50 10 C75 10, 90 45, 90 80 C90 115, 75 130, 50 130 C25 130, 10 115, 10 80 C10 45, 25 10, 50 10 Z"
              fill="rgb(0, 0, 0, 0.025)"
              stroke="rgb(0, 0, 0, 0.15)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
          </svg>
        );
      } else {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 140">
            <path
              d="M50 10 C75 10, 90 45, 90 80 C90 115, 75 130, 50 130 C25 130, 10 115, 10 80 C10 45, 25 10, 50 10 Z"
              fill={getRandomEasterColor()}
              stroke="rgb(0, 0, 0, 0.15)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
    case 'halloween':
      if (outlined) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 90 90">
            <path
              className="svg-hover add-halloween"
              d="M50 12 C74 12,92 32,85 58 C92 73,74 88,50 88 C26 88,8 73,15 58 C8 32,26 12,50 12 Z"
              fill="rgba(0,0,0,0)"
              stroke="rgba(0,0,0,0.25)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
            <path
              className="svg-hover add-halloween"
              d="M50 12 C59 12,74 32,68 58 C74 73,59 88,50 88 M50 12 C41 12,26 32,32 58 C26 73,41 88,50 88"
              fill="rgba(0,0,0,0)"
              stroke="rgba(0,0,0,0.25)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
            <rect x="44" y="6" width="12" height="16" rx="4" ry="4" fill="rgba(0,0,0,0.25)" stroke="rgba(0,0,0,0.25)" strokeWidth="8" />
          </svg>
        );
      } else {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 90 90">
            <path
              className="svg-hover add-halloween"
              d="M50 12 C74 12,92 32,85 58 C92 73,74 88,50 88 C26 88,8 73,15 58 C8 32,26 12,50 12 Z"
              fill="rgb(255, 128, 0, 0.5)"
              stroke="rgb(255, 128, 0, 0.5)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
            <path
              className="svg-hover add-halloween"
              d="M50 12 C59 12,74 32,68 58 C74 73,59 88,50 88 M50 12 C41 12,26 32,32 58 C26 73,41 88,50 88"
              fill="rgb(255, 128, 0, 0.5)"
              stroke="rgb(255, 128, 0, 0.5)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
            <rect x="44" y="6" width="12" height="16" rx="4" ry="4" fill="rgb(0, 128, 0, 0.75)" stroke="rgb(0, 128, 0, 0.75)" strokeWidth="8" />
          </svg>
        );
      }
    case 'valentines':
      if (outlined) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 95 95">
            <path
              className="svg-hover add-valentines"
              d="M50 86 L16 50 A20 20 0 0 1 50 28 A20 20 0 0 1 84 50 Z"
              fill="rgba(0, 0, 0, 0)"
              stroke="rgba(0, 0, 0, 0.25)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
          </svg>
        );
      } else {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 95 95">
            <path
              d="M50 86 L16 50 A20 20 0 0 1 50 28 A20 20 0 0 1 84 50 Z"
              fill="rgb(220, 20, 60, 0.5)"
              stroke="rgb(220, 20, 60, 0.5)"
              strokeWidth="8"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
    case 'starwars': {
      const saberColor = getRandomLightsaberColor();
      if (outlined) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <defs>
              <filter id="saber-glow-outline" x="-100%" y="-100%" width="300%" height="300%">
                <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                <feMerge>
                  <feMergeNode in="coloredBlur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <g transform="rotate(-45, 50, 50)">
              <path
                className="svg-hover add-starwars"
                d="M42 10 Q42 2 50 2 Q58 2 58 10 L58 68 L42 68 Z"
                fill="rgba(0, 0, 0, 0)"
                stroke="rgba(0, 0, 0, 0.25)"
                strokeWidth="5"
                strokeLinejoin="round"
                filter="url(#saber-glow-outline)"
              />
              <rect x="42" y="68" width="16" height="28" rx="3" fill="rgba(0, 0, 0, 0.25)" stroke="rgba(0, 0, 0, 0.25)" strokeWidth="8" />
            </g>
          </svg>
        );
      } else {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <defs>
              <filter id="saber-glow" x="-100%" y="-100%" width="300%" height="300%">
                <feGaussianBlur stdDeviation="4" result="coloredBlur" />
                <feMerge>
                  <feMergeNode in="coloredBlur" />
                  <feMergeNode in="coloredBlur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <g transform="rotate(-45, 50, 50)">
              <path d="M42 10 Q42 2 50 2 Q58 2 58 10 L58 68 L42 68 Z" fill={saberColor} filter="url(#saber-glow)" />
              <rect x="42" y="68" width="16" height="28" rx="3" fill="rgba(0, 0, 0, 0.25)" stroke="rgba(0, 0, 0, 0.25)" strokeWidth="8" />
            </g>
          </svg>
        );
      }
    }
    case 'earthday':
      if (outlined) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <clipPath id="globe-clip-outline">
              <circle cx="50" cy="50" r="38" />
            </clipPath>
            <circle className="svg-hover add-earthday" cx="50" cy="50" r="42" fill="rgba(0, 0, 0, 0)" stroke="rgba(0, 0, 0, 0.25)" strokeWidth="7" />
            <g clipPath="url(#globe-clip-outline)" transform="translate(50,50) scale(0.85) translate(-50,-50)">
              {/* North America - more detailed shape */}
              <path
                className="svg-hover add-earthday"
                d="M12 22 Q14 18 20 16 L28 14 Q32 16 36 14 L42 16 Q46 20 44 26 L46 32 Q44 36 40 40 L36 44 Q32 48 28 46 L22 50 Q18 48 16 44 L14 38 Q10 32 12 26 Z"
                fill="rgba(0, 0, 0, 0.15)"
              />
              {/* Greenland */}
              <path className="svg-hover add-earthday" d="M38 12 Q42 10 46 12 L48 16 Q46 20 42 20 L38 18 Q36 16 38 12 Z" fill="rgba(0, 0, 0, 0.15)" />
              {/* South America - triangular with bulge */}
              <path
                className="svg-hover add-earthday"
                d="M28 54 Q32 52 36 54 L40 58 Q42 64 40 70 L38 78 Q34 84 30 86 L26 82 Q24 76 24 70 L22 62 Q24 56 28 54 Z"
                fill="rgba(0, 0, 0, 0.15)"
              />
              {/* Europe */}
              <path className="svg-hover add-earthday" d="M48 22 Q54 18 64 22 Q70 28 68 38 Q60 40 52 36 Q46 30 48 22 Z" fill="rgba(0, 0, 0, 0.15)" />
              {/* Africa - distinctive shape */}
              <path
                className="svg-hover add-earthday"
                d="M52 38 Q56 36 62 38 L68 42 Q72 46 72 52 L70 60 Q68 68 64 74 L58 78 Q54 76 52 72 L50 64 Q48 56 48 50 L50 44 Q50 40 52 38 Z"
                fill="rgba(0, 0, 0, 0.15)"
              />
              {/* Asia - large landmass */}
              <path
                className="svg-hover add-earthday"
                d="M66 18 Q72 14 80 16 L88 20 Q92 26 90 34 L88 42 Q86 48 80 52 L72 54 Q66 52 64 46 L62 38 Q60 30 62 24 L64 20 Q64 18 66 18 Z"
                fill="rgba(0, 0, 0, 0.15)"
              />
            </g>
          </svg>
        );
      } else {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <clipPath id="globe-clip">
              <circle cx="50" cy="50" r="38" />
            </clipPath>
            <circle cx="50" cy="50" r="42" fill="rgba(65, 135, 206, 0.5)" stroke="rgba(65, 135, 206, 0.5)" strokeWidth="7" />
            <g clipPath="url(#globe-clip)" transform="translate(50,50) scale(0.85) translate(-50,-50)">
              {/* North America */}
              <path
                d="M12 22 Q14 18 20 16 L28 14 Q32 16 36 14 L42 16 Q46 20 44 26 L46 32 Q44 36 40 40 L36 44 Q32 48 28 46 L22 50 Q18 48 16 44 L14 38 Q10 32 12 26 Z"
                fill="rgba(34, 139, 34, 0.7)"
              />
              {/* Greenland */}
              <path d="M38 12 Q42 10 46 12 L48 16 Q46 20 42 20 L38 18 Q36 16 38 12 Z" fill="rgba(34, 139, 34, 0.7)" />
              {/* South America */}
              <path d="M28 54 Q32 52 36 54 L40 58 Q42 64 40 70 L38 78 Q34 84 30 86 L26 82 Q24 76 24 70 L22 62 Q24 56 28 54 Z" fill="rgba(34, 139, 34, 0.7)" />
              {/* Europe */}
              <path d="M48 22 Q54 18 64 22 Q70 28 68 38 Q60 40 52 36 Q46 30 48 22 Z" fill="rgba(34, 139, 34, 0.7)" />
              {/* Africa */}
              <path
                d="M52 38 Q56 36 62 38 L68 42 Q72 46 72 52 L70 60 Q68 68 64 74 L58 78 Q54 76 52 72 L50 64 Q48 56 48 50 L50 44 Q50 40 52 38 Z"
                fill="rgba(34, 139, 34, 0.7)"
              />
              {/* Asia */}
              <path
                d="M66 18 Q72 14 80 16 L88 20 Q92 26 90 34 L88 42 Q86 48 80 52 L72 54 Q66 52 64 46 L62 38 Q60 30 62 24 L64 20 Q64 18 66 18 Z"
                fill="rgba(34, 139, 34, 0.7)"
              />
            </g>
          </svg>
        );
      }
    default:
      if (outlined) {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <path
              className="svg-hover add-favorite"
              d="M50 5 L61 39 L98 39 L67 61 L79 95 L50 75 L21 95 L33 61 L2 39 L39 39 Z"
              fill="rgba(0, 0, 0, 0)"
              stroke="rgba(0, 0, 0, 0.25)"
              strokeWidth="7"
              strokeLinejoin="round"
            />
          </svg>
        );
      } else {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <path
              d="M50 5 L61 39 L98 39 L67 61 L79 95 L50 75 L21 95 L33 61 L2 39 L39 39 Z"
              fill="rgba(184, 115, 51, 0.5)"
              stroke="rgba(184, 115, 51, 0.5)"
              strokeWidth="7"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
  }
};

// Berechnet Ostersonntag nach dem Computus-Algorithmus (Meeus/Jones/Butcher)
function getEasterSunday(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, month - 1, day);
}

function isEasterWeek(): boolean {
  const today = new Date();
  const easterSunday = getEasterSunday(today.getFullYear());
  const weekStart = new Date(easterSunday);
  weekStart.setDate(easterSunday.getDate() - 6);

  return today >= weekStart && today <= easterSunday;
}

function getRandomEasterColor() {
  const colors = [
    'rgba(128, 0, 128, 0.25)',
    'rgba(173, 216, 230, 1)',
    'rgba(0, 128, 0, 0.25)',
    'rgba(220, 20, 60, 0.5)',
    'rgba(255, 255, 0, 0.25)',
    'rgba(255, 165, 0, 0.5)',
  ];

  return colors[Math.floor(Math.random() * colors.length)];
}

function getRandomLightsaberColor() {
  const colors = ['rgba(100, 160, 210, 0.5)', 'rgba(0, 128, 0, 0.25)', 'rgba(210, 90, 90, 0.5)', 'rgba(150, 100, 180, 0.5)'];

  return colors[Math.floor(Math.random() * colors.length)];
}
